// assistantBridge.js — Bridge between Survey Assistant and Designer state
//
// Validates incoming .cloudsam JSON and converts it to the designer's
// {survey, nodes, edges} format using reconstructPayloadFromDescriptor.
//
// Usage (from browser console, embedded assistant, or postMessage):
//   window.__designerLoadSurvey(descriptorJson)
//   window.dispatchEvent(new CustomEvent('assistant-load-survey', { detail: descriptorJson }))

import { reconstructPayloadFromDescriptor } from './payloadRecovery';

/**
 * Validate and convert a .cloudsam descriptor into a designer-loadable payload.
 *
 * @param {object} descriptor - Raw .cloudsam JSON (with survey_descriptor, questions, flow)
 * @returns {{ success: boolean, payload?: object, error?: string }}
 */
export function preparePayload(descriptor) {
    if (!descriptor || typeof descriptor !== 'object') {
        return { success: false, error: 'Descriptor must be a non-null object' };
    }
    if (!Array.isArray(descriptor.questions) || descriptor.questions.length === 0) {
        return { success: false, error: 'Descriptor must have a non-empty questions array' };
    }
    if (!Array.isArray(descriptor.flow)) {
        return { success: false, error: 'Descriptor must have a flow array' };
    }

    try {
        const payload = reconstructPayloadFromDescriptor(descriptor);
        if (!payload) {
            return { success: false, error: 'reconstructPayloadFromDescriptor returned null' };
        }
        return { success: true, payload };
    } catch (err) {
        return { success: false, error: `Conversion failed: ${err.message}` };
    }
}
